import { takeLatest, put, call } from 'redux-saga/effects';

import { listContaChequePreDatadoCadastro } from '../service';
import {
  TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO,
  TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
  TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
  TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListContaChequePreDatadoCadastro(action) {
  yield put({ type: TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING })

  try {
    const table = yield call(listContaChequePreDatadoCadastro, action.args)
    yield put({ type: TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListContaChequePreDatadoCadastro() {
  yield takeLatest(TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO, sagaListContaChequePreDatadoCadastro)
}